<template>
  <div :style="styleObject" ref="tableBox">
    <el-select
      v-if="options.openTableFilter && !isTime"
      style="width: 140px"
      v-model="filterValue"
      placeholder="请选择"
      class="select-box"
      :filterable="request_prefix === 'bigScreen' ? true : false"
      clearable
      ref="tableFilter"
      @change="changeFilterValue()"
    >
      <el-option v-for="(item, index) in filterList" :key="index" :label="item" :value="index"> </el-option>
    </el-select>
    <div class="time-box" v-if="isTime"></div>
    <div v-if="showHeader" class="header" :style="headerStyleObject">
      <div v-if="options.isShowSerialNumber && options.isShowRank && cloneListData.length >= 1" :style="thStyle(0, true)">
        {{ cloneHeaderSerialNumberData }}
      </div>
      <template v-for="(item, index) in cloneHeaderData">
        <div
          v-if="index < cloneHeaderData.length - 1"
          :style="{ ...thStyle(index), ...dataGroupHeaderStyle(index) }"
          :title="item"
          :key="index"
        >
          {{ item }}
        </div>
        <!-- 样式区分解决样式1最后一列表头文字位置设置失效的问题 -->
        <div v-else-if="!options.isShowSerialNumber" :key="index" :style="{ ...thStyle(index,false,false) }">{{ item }}</div>
        <div v-else :key="index" :style="{ ...thStyle(index,false,true) }">{{ item }}</div>
      </template>
    </div>
    <TableCore
      ref="tableScroll"
      v-if="cloneListData.length >= 1"
      :classOption="classOption"
      :data="cloneListData"
      class="tableComponent"
      @requestNextPage="requestNextPage"
    >
      <ul class="item" :style="defaultStyle">
        <li
          v-for="(item, index) in cloneListData"
          :key="index"
          :style="{ ...((index + 1) % 2 == 0 ? evenBgStyle : oddBgStyle), ...specialRowsStyle(index), ...sameBgStyle }"
        >
          <div
            v-if="options.isShowSerialNumber && options.isShowRank"
            :style="{ ...tdStyle(0, true), ...serialNumberStyle() }"
          >
            <div :style="{ ...serialNumberTdStyle(), ...serialNumberSpecialRowsStyle(index) }">
              <span :class="options.serialNumberBgType === 'diamond' ? 'rotate_45' : ''">{{
                cloneListSerialNumberData[index]
              }}</span>
            </div>
          </div>
          <template v-for="(value, index1) in item">
            <div
              v-if="index1 < item.length - 1 && getValueDisplayType(index1) === 'text'"
              :style="{ ...tdStyle(index1), ...dataGroupContentStyle(index1) }"
              :title="value"
              :key="index1"
              :class="options.overflowText !== 'wrap' ? 'overflowHid' : 'lineHeight1'"
            >
              {{ formatStr(index1, value) }}
            </div>
            <div
              v-else-if="index1 < item.length - 1 && getValueDisplayType(index1) === 'image'"
              :key="index1"
              :style="{ ...tdStyle(index1), ...dataGroupHeaderStyle(index1) }"
            >
              <img :src="value" :style="dataGroupContentStyle(index1)" />
            </div>
            <div
              v-else
              :key="index1"
              :style="{ ...tdStyle(index1,false,true), ...dynamicDataStyle(index, index1) }"
              :title="value"
              :class="options.overflowText !== 'wrap' ? 'overflowHid' : 'lineHeight1'"
            >
              {{ value }}
            </div>
          </template>
        </li>
      </ul>
    </TableCore>
    <div class="table-pagination" v-if="openPagination && options.showRowsType === 'customize'">
      <el-pagination
        ref="page"
        prev-text=""
        next-text=""
        :pager-count="maxPageBtnNum"
        :style="getPaginationStyle"
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="options.showRows"
        :total="totalRecords"
      >
      </el-pagination>
    </div>

    <!-- 空数据 -->
    <div class="null-data" v-if="cloneListData.length === 0">
      <img src="../../../assets/images/img-null-data-light.png" alt="" />
      <p v-if="errorCode" class="textColor">{{ errorCode }}报错</p>
      <p v-else>暂无数据</p>
    </div>
  </div>
</template>

<script>
import { hasProperty } from "utils"
import plugins from "./plugin"
import { updateNormalRect } from "utils/updateData/publicDataUtils/updateNormalRect.js"
import TableCore from "./tableCore"
import eventMixin from "utils/event/eventMixin.js"
import dataRenderMixin from "materials/dataRenderMixin"

export default {
  mixins: [eventMixin, plugins, dataRenderMixin],
  name: "Table",
  components: { TableCore },
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      classOption: {
        autoPlay: this.options.turnOnScroll,
        hoverStop: this.options.hoverStopScroll,
        waitTime: this.options.waitTime * 1000,
        singleHeight: this.options.rowsHeight,
        tbodyHeight: this.options.height - this.options.headerHeight
      },
      cloneHeaderData: null,
      cloneHeaderSerialNumberData: "排名",
      cloneListData: null,
      cloneListSerialNumberData: [],
      dynamicDataStyleList: [],
      reloadTimer: null, // 用于数据轮询
      serialNumberHeaderDataLocal: [],
      filterList: [],
      filterValue: "",
      isSearch: false,
      pageSize: 50,
      pageNum: 1,
      totalRecords: 1,
      dataAllBox: [],
      currentPage: 1,
      dateVal: ""
    }
  },
  watch: {
    "options.isShowSerialNumber": function (newVal, oldVal) {
      this.init()
    },
    "options.headerData": function (newVal, oldVal) {
      this.init()
    },
    "options.listData": function (newVal, oldVal) {
      this.init()
    },
    "options.isShowRank": function (newVal, oldVal) {
      this.init()
    },
    "options.turnOnScroll": function (n, o) {
      this.classOption.autoPlay = n
      if (this.isBigScreenPreview() && this.noCacheComponent && n) {
        // 自动滚动切换，重新请求数据并进行滚动分页操作
        this.dataAllBox = []
        this.pageNum = 1
        //根绝接口返回数据来判断，
        this.updateData()
      }
      this.$refs.tableScroll.reset()
      this.setSelfScroll()
    },
    "options.hoverStopScroll": function (n, o) {
      this.classOption.hoverStop = n
      this.$refs.tableScroll.reset()
    },
    "options.waitTime": function (n, o) {
      this.classOption.waitTime = n * 1000
      if (this.classOption.autoPlay) {
        this.$refs.tableScroll.reset()
      }
    },
    "options.rowsHeight": function (n, o) {
      this.classOption.singleHeight = n
      if (this.classOption.autoPlay) {
        this.$refs.tableScroll.reset()
      }
    },
    "options.showRowsType": function (n, o) {
      if (n === "customize") {
        this.init()
        this.cloneListData.length = this.options.showRows
      } else {
        this.init()
      }
    },
    "options.showRows": function (n, o) {
      if (this.options.showRowsType === "customize") {
        this.init()
        this.cloneListData.length = n
      }
    },
    "options.showColsType": function (n, o) {
      if (n === "customize") {
        this.init()
        this.cloneHeaderData.length = this.options.showCols
        this.cloneListData.forEach(item => {
          item.length = this.options.showCols
        })
      } else {
        this.init()
      }
    },
    "options.showCols": function (n, o) {
      if (this.options.showColsType === "customize") {
        this.init()
        this.cloneHeaderData.length = n
        this.cloneListData.forEach(item => {
          item.length = n
        })
      }
    },
    "options.dynamicData": {
      handler(n, o) {
        this.init()
      },
      deep: true
    },
    "options.dynamicHeaderName": function (n, o) {
      this.init()
    },
    "options.filedMappingValue": function (n, o) {
      if (n != o) {
        this.filterValue = ""
        this.updateData()
      }
    },
    "options.scrollAutoSelf": function (n, o) {
      this.setSelfScroll()
    },
    "options.height": function (n, o) {
      this.setSelfScroll()
    },
    "options.rankName": function (n, o) {
      if(n !== o){
        this.cloneHeaderSerialNumberData = n
      }
    },
  },
  created() {
    this.init()
    if(this.options.rankName !== undefined){
      this.cloneHeaderSerialNumberData = this.options.rankName
    }
  },
  mounted() {
    if (this.noCacheComponent) {
      if (window.chartEventBus) {
        this.addChartEvent()
        this.chartEventFilterValue()
      } else {
        this.updateData()
      }
      if (this.isBigScreenPreview() && this.options.autoUpdate !== false) {
        this.reloadTimer = setInterval(() => {
          //自动更新数据时需要清空分页和表格数据
          this.pageNum = 1
          this.dataAllBox = []
          this.updateData()
        }, this.updateTimer + Math.floor(Math.random() * 5000))
      }
    } else {
      // 初始化插件系统
      this.$initPlugin(this.options?.pluginName)
    }
    setTimeout(() => {
      this.setSelfScroll()
    }, 300)
    this.$eventBus.$on(`update-table-data-eventBus-${this.myid.container_id}-${this.myid.rect_id}`, msg => {
      console.log('msg :>>',msg);
      if (msg.hasOwnProperty("dateVal")) {
        this.dateVal = msg.dateVal
        this.updateData()
      }
    })
    //获取数据推送需要的属性
    if(this.options.appId){
     this.etEngineInstance()
    }
  },
  destroyed() {
    if (this.reloadTimer) {
      clearInterval(this.reloadTimer)
      this.reloadTimer = null
    }
    clearInterval(this.animateReloadTimer)
    this.animateReloadTimer = null
  },
  computed: {
    isTime() {
      const lable = this.options?.filedMappingList?.find(item => item.value === this.filedMappingValue)?.label
      return lable?.includes("时间")
    },
    updateTimer() {
      if (!this.options.updateTimer) {
        this.$changeOptionsEV(600, "updateTimer", false, false, false, true)
        return 600 * 1000
      }
      return this.options.updateTimer * 1000
    },
    noCacheComponent() {
      return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : this.options.appId || false
    },
    styleObject() {
      let transformStr = {}
      if (this.request_prefix === "bigScreen") {
        transformStr = {
          transform: "rotate(" + this.options.rotate + "deg)"
        }
      }
      return {
        // width: this.options.width + "px",
        width: "100%",
        height: "100%",
        // height: this.options.height + "px",
        overflow: "hidden",
        ...transformStr
      }
    },
    showHeader() {
      return this.options.showHeader
    },
    colsWidthType() {
      return this.options.colsWidthType
    },
    showPagination() {
      return this.options.showPagination
    },
    headerStyleObject() {
      return {
        height: this.options.headerHeight + "px",
        "font-Family": this.options.headerFontFamily,
        "font-size": this.options.headerFontSize + "px",
        "font-weight": this.options.headerFontWeight,
        color: this.$parseColor(this.options.headerFontColor),
        background: this.$parseColor(this.options.headerBgColor)
      }
    },
    defaultStyle() {
      return {
        "font-Family": this.options.defaultFontFamily,
        "font-size": this.options.defaultFontSize + "px",
        "font-weight": this.options.defaultFontWeight,
        color: this.$parseColor(this.options.defaultFontColor)
      }
    },
    oddBgStyle() {
      let oddBgStyle = {}
      switch (this.options.oddBgColorType) {
        case "纯色":
          oddBgStyle = {
            background: this.$parseColor(this.options.oddBgColor)
          }
          break
        case "线性渐变":
          oddBgStyle = {
            "background-image":
                `linear-gradient(90deg,${this.$parseColor(this.options.oddBgStartColor)},${this.$parseColor(this.options.oddBgEndColor)})`
          }
          break
      }
      return oddBgStyle
    },
    evenBgStyle() {
      let evenBgStyle = {}
      switch (this.options.evenBgColorType) {
        case "纯色":
          evenBgStyle = {
            background: this.$parseColor(this.options.evenBgColor)
          }
          break
        case "线性渐变":
          evenBgStyle = {
            "background-image": `linear-gradient(90deg,${
              this.$parseColor(this.options.evenBgStartColor)},${ this.$parseColor(this.options.evenBgEndColor)})`
          }
          break
      }
      return evenBgStyle
    },
    sameBgStyle() {
      let sameBgStyle = {}
      if (this.options.overflowText === "wrap") {
        sameBgStyle = {
          "align-items": "center",
          "min-height": this.options.rowsHeight + "px",
          "line-height": 1.5,
          "word-break": "break-all"
        }
      } else {
        sameBgStyle = {
          height: this.options.rowsHeight + "px",
          "line-height": this.options.rowsHeight + "px"
        }
      }
      return sameBgStyle
    },
    filedMappingValue() {
      return this.options.filedMappingValue || ""
    },
    errorCode() {
      return this.options && this.options.errorCode
    },
    maxPageBtnNum() {
      return this.options && this.options.maxPageBtnNum || 7
    },
    openPagination() {
      return this.options && this.options.openPagination || false
    },
    getPaginationStyle() {
      const themeColor = this.$store.state[this.request_prefix].page.themeColor
      const color = this.request_prefix === "bigScreen" ? "rgba(255,255,255,1)" : "rgba(0,0,0,1)"
      return {
        "textAlign": this.options.pagePosition || "center",
        "--fontSize": this.options.positionSize + "px" || "14px",
        "--fontColor":
            this.$parseColor(this.options.positionColor,{isThemeColor:this.options.positionIsThemeColor}) || color,
        "--activeFontColor":  this.$parseColor(this.options.positionActiveColor,{isThemeColor:this.options.positionActiveIsThemeColor}) || color,
      }
    },
  },
  methods: {
    // 表格数据在自动滚动时，需要判断：以50条分页为例，若数据大于50条，需要在开始滚动时请求第二页数据，当滚动到第二页的第一条时需要请求第三页数据，以此类推。
    async updateData() {
      if (!this.isSearch && this.options.hasSearch) {
        this.$changeOptionsEV(false, "hasSearch", false, null, this.myid, true)
      }
      if (!this.isTime) this.dateVal = ""
      const openPagination = this.openPagination && this.options?.showRowsType === 'customize'
      if (openPagination) {
        this.pageSize = this.options.showRows
      }
      updateNormalRect
        .call(
          this,
          (datas, totalRecords) => {
            this.totalRecords = totalRecords
            // 组装数据
            this.updateDataCb(datas)
            //  预览页中，手动滚动需要加载完所有数据：解决表单的数据只加载50条的问题
            if (
              this.options.scrollAutoSelf &&
              !this.options.turnOnScroll &&
              this.isBigScreenPreview() &&
              this.totalRecords > this.pageSize &&
              !openPagination
            ) {
              //表单数据请求返回数据最大100条，需要根据分页数据请求
              if (this.pageNum <= Math.ceil(this.totalRecords / this.pageSize) - 1) {
                this.pageNum++
                this.updateData()
              }
            }
          },
          this.pageSize,
          this.pageNum,
          this.dateVal
        )
        .catch(e => {
          if (e === "接口数据为空") {
            this.$changeOptionsEV([], "listData", false, "", this.myid, true)
          }
        })
    },
    updateDataCb(datas) {
      console.log("datas tabel", datas)
      // 组装数据
      let filterList = []
      const sourceData = datas
      let headerData = [] //表头数据
      let listData = [] //表格内容
      let listOtherData = [] // 表格额外内容
      for (let i = 0; i < sourceData.length; i++) {
        let param = []
        let otherParam = []
        Object.keys(sourceData[i]).forEach(item => {
          // 防止添加重复的表头数据
          if (
            typeof sourceData[i][item] == "object" &&
            sourceData[i][item] !== null &&
            sourceData[i][item] !== undefined
          ) {
            if (!headerData.includes(sourceData[i][item].key)) {
              headerData.push(sourceData[i][item].key)
            }
            param.push(sourceData[i][item].value)
            if (item === this.filedMappingValue && !filterList.includes(sourceData[i][item].value)) {
              sourceData[i][item].value ? filterList.push(sourceData[i][item].value) : ""
            }
          } else {
            otherParam[item] = sourceData[i][item]
          }
        })
        listData.push(param)
        listOtherData.push(otherParam)
        !this.isSearch ? (this.filterList = filterList) : ""
      }
      if (this.options.isShowSerialNumber && this.pageNum <= 1) {
        try {
          let serialNumberHeaderData = []
          for (let i = 0; i < headerData.length; i++) {
            // const param = {
            //   value: headerData[i], // 列名
            //   align: "center", // 内容对齐方式 "left/center/right"
            //   type: "text", // 字段显示方式 "text/image"
            //   isDesensitization: false, // 是否脱敏
            //   width: 20,
            //   height: 20,
            //   borderRadius: 6,
            //   fontSize: 12,
            //   fontFamily: "sans-serif",
            //   fontWeight: "400",
            //   fontColor: "rgba(255, 255, 255, 0.8)"
            // }
            let serialNumberHeaderDataItem = []
            if (!this.options.serialNumberHeaderData || this.options.serialNumberHeaderData.length === 0) {
              serialNumberHeaderDataItem = JSON.parse(JSON.stringify(this.serialNumberHeaderDataLocal[i]))
            } else {
              serialNumberHeaderDataItem = JSON.parse(JSON.stringify(this.options.serialNumberHeaderData[i]))
            }
            serialNumberHeaderDataItem.value = headerData[i]
            serialNumberHeaderData.push(serialNumberHeaderDataItem)
          }
          this.$changeOptionsEV(serialNumberHeaderData, "serialNumberHeaderData", false, "", this.myid, true)
        } catch (e) {
          console.log(e)
        }
      }
      if(this.pageNum <= 1){
        this.$changeOptionsEV(headerData, "headerData", false, "", this.myid, true)
      }
      this.$changeOptionsEV(listData, "listData", false, "", this.myid, true)
      this.$changeOptionsEV(listOtherData, "listOtherData", false, "", this.myid, true)
      this.$changeOptionsEV(this.filterList, "filterList", false, "", this.myid, true)
      // 初始化插件系统
      this.$initPlugin(this.options?.pluginName)
      if (
        this.isBigScreenPreview() &&
        (this.options.turnOnScroll || this.options.scrollAutoSelf) &&
        this.totalRecords > this.dataAllBox.length &&
        !(this.openPagination && this.options?.showRowsType === 'customize')
      ) {
        //自动滚动时。请求的分页数据组合在一起，传递给表数据，
        //手动滚动已添加分页请求
        this.dataAllBox.push(...listData)
        this.$changeOptionsEV(this.dataAllBox, "listData", false, "", this.myid, true)
        this.init()
      }
    },
    init() {
      this.cloneHeaderData = JSON.parse(JSON.stringify(this.options.headerData))
      this.cloneListData = JSON.parse(JSON.stringify(this.options.listData))
      // this.totalRecords = this.cloneListData.length
      // 排序表格数据组装
      if (this.options.isShowSerialNumber && this.cloneListData.length >= 1) {
        this.cloneListSerialNumberData = []
        if (this.options.dynamicHeaderName) {
          this.cloneHeaderData.push(this.options.dynamicHeaderName)
        }
        for (let i = 0; i < this.cloneListData.length; i++) {
          if (this.options.isShowRank) {
            this.cloneListSerialNumberData.push(i + 1)
          }
          if (this.cloneListData[i]) {
            if (this.cloneListData[i].length < this.cloneHeaderData.length) {
              this.cloneListData[i].push("")
            } else if (this.cloneListData[i].length > this.cloneHeaderData.length) {
              this.cloneListData[i].pop()
            }
          }
        }
        this.dynamicDataStyleList = []
        this.updateDynamicData()
        this.serialNumberHeaderDataLocal = JSON.parse(JSON.stringify(this.options.serialNumberHeaderData))
      }
      if (this.options.showColsType === "customize") {
        this.cloneHeaderData.length = this.options.showCols
        this.cloneListData.forEach(item => {
          item.length = this.options.showCols
        })
      } else {
        // 新的头数据和旧的头宽度数据长度不一致, 说明头部是有删减, 更新一波自定义列表的数据，同时更新数据表格
        if (this.cloneHeaderData.length !== this.options.colsWidthList.length) {
          const newHeadLength = this.cloneHeaderData.length
          const currentColLength = this.cloneListData[0]?.length
          let newListData = this.cloneListData
          const newColsWidthList = new Array(this.cloneHeaderData.length).fill(
            Math.floor(100 / this.cloneHeaderData.length)
          )
          if (newHeadLength > currentColLength) {
            newListData = this.cloneListData.map(item =>
              item.concat(new Array(newHeadLength - currentColLength).fill(""))
            )
          }
          this.$changeOptionsEV(newColsWidthList, "colsWidthList", false, "", this.myid, true)
          this.$changeOptionsEV(newListData, "listData", false, "", this.myid, true)
        }
      }
      if (this.options.showRowsType === "customize") {
        // if (this.openPagination) {
        //   var startIndex = (this.currentPage - 1) * this.options.showRows;
        //   var endIndex = this.currentPage * this.options.showRows;
        //   this.cloneListData = this.cloneListData.slice(startIndex, endIndex);
        // } else {
        //   this.cloneListData.length = this.options.showRows
        // }
        this.cloneListData.length = this.options.showRows
      }
    },
    // 更新动态数据
    updateDynamicData() {
      // 遍历动态数据条件
      for (let i = 0; i < this.options.dynamicData.length; i++) {
        const dynamicDataItem = this.options.dynamicData[i]
        const index = this.options.headerData.indexOf(dynamicDataItem.target)
        for (let j = 0; j < this.options.listData.length; j++) {
          const listDataItem = this.options.listData[j]
          if (dynamicDataItem.type === "singleValue") {
            switch (dynamicDataItem.condition) {
              case "等于":
                if (listDataItem[index] === dynamicDataItem.parameter) {
                  this.cloneListData[j][this.cloneListData[j].length - 1] = dynamicDataItem.result
                  const temp = {
                    index: j,
                    style: {
                      "font-size": dynamicDataItem.resultFontSize + "px",
                      "font-family": dynamicDataItem.resultFontFamily,
                      "font-weight": dynamicDataItem.resultFontWeight,
                      color: this.$parseColor(dynamicDataItem.resultFontColor)
                    }
                  }
                  if (!this.dynamicDataStyleList.find(item => item.index === temp.index)) {
                    this.dynamicDataStyleList.push(temp)
                  }
                  continue
                }
                break
              case "不等于":
                if (listDataItem[index] !== dynamicDataItem.parameter) {
                  this.cloneListData[j][this.cloneListData[j].length - 1] = dynamicDataItem.result
                  const temp = {
                    index: j,
                    style: {
                      "font-size": dynamicDataItem.resultFontSize + "px",
                      "font-family": dynamicDataItem.resultFontFamily,
                      "font-weight": dynamicDataItem.resultFontWeight,
                      color: this.$parseColor(dynamicDataItem.resultFontColor)
                    }
                  }
                  if (!this.dynamicDataStyleList.find(item => item.index === temp.index)) {
                    this.dynamicDataStyleList.push(temp)
                  }
                  continue
                }
                break
              case "包含":
                if (listDataItem[index].indexOf(dynamicDataItem.parameter) !== -1) {
                  this.cloneListData[j][this.cloneListData[j].length - 1] = dynamicDataItem.result
                  const temp = {
                    index: j,
                    style: {
                      "font-size": dynamicDataItem.resultFontSize + "px",
                      "font-family": dynamicDataItem.resultFontFamily,
                      "font-weight": dynamicDataItem.resultFontWeight,
                      color: this.$parseColor(dynamicDataItem.resultFontColor)
                    }
                  }
                  if (!this.dynamicDataStyleList.find(item => item.index === temp.index)) {
                    this.dynamicDataStyleList.push(temp)
                  }
                  continue
                }
                break
              case "不包含":
                if (listDataItem[index].indexOf(dynamicDataItem.parameter) === -1) {
                  this.cloneListData[j][this.cloneListData[j].length - 1] = dynamicDataItem.result
                  const temp = {
                    index: j,
                    style: {
                      "font-size": dynamicDataItem.resultFontSize + "px",
                      "font-family": dynamicDataItem.resultFontFamily,
                      "font-weight": dynamicDataItem.resultFontWeight,
                      color: this.$parseColor(dynamicDataItem.resultFontColor)
                    }
                  }
                  if (!this.dynamicDataStyleList.find(item => item.index === temp.index)) {
                    this.dynamicDataStyleList.push(temp)
                  }
                  continue
                }
                break
              case "大于":
                if (listDataItem[index] > dynamicDataItem.parameter) {
                  this.cloneListData[j][this.cloneListData[j].length - 1] = dynamicDataItem.result
                  const temp = {
                    index: j,
                    style: {
                      "font-size": dynamicDataItem.resultFontSize + "px",
                      "font-family": dynamicDataItem.resultFontFamily,
                      "font-weight": dynamicDataItem.resultFontWeight,
                      color: this.$parseColor(dynamicDataItem.resultFontColor)
                    }
                  }
                  if (!this.dynamicDataStyleList.find(item => item.index === temp.index)) {
                    this.dynamicDataStyleList.push(temp)
                  }
                  continue
                }
                break
              case "小于":
                if (listDataItem[index] < dynamicDataItem.parameter) {
                  this.cloneListData[j][this.cloneListData[j].length - 1] = dynamicDataItem.result
                  const temp = {
                    index: j,
                    style: {
                      "font-size": dynamicDataItem.resultFontSize + "px",
                      "font-family": dynamicDataItem.resultFontFamily,
                      "font-weight": dynamicDataItem.resultFontWeight,
                      color: this.$parseColor(dynamicDataItem.resultFontColor)
                    }
                  }
                  if (!this.dynamicDataStyleList.find(item => item.index === temp.index)) {
                    this.dynamicDataStyleList.push(temp)
                  }
                  continue
                }
                break
            }
          } else {
            if (
              Number(listDataItem[index]) > Number(dynamicDataItem.conditionRange[0]) &&
              Number(listDataItem[index]) <= Number(dynamicDataItem.conditionRange[1])
            ) {
              this.cloneListData[j][this.cloneListData[j].length - 1] = dynamicDataItem.result
              const temp = {
                index: j,
                style: {
                  "font-size": dynamicDataItem.resultFontSize + "px",
                  "font-family": dynamicDataItem.resultFontFamily,
                  "font-weight": dynamicDataItem.resultFontWeight,
                  color: this.$parseColor(dynamicDataItem.resultFontColor)
                }
              }
              if (!this.dynamicDataStyleList.find(item => item.index === temp.index)) {
                this.dynamicDataStyleList.push(temp)
              } else {
                this.dynamicDataStyleList[temp.index].style = temp.style
              }
              continue
            }
          }
        }
      }
    },
    serialNumberTdStyle() {
      // 排序表格样式
      let style = {}
      if (this.options.isShowSerialNumber) {
        style["font-size"] = this.options.serialNumberRankTextFontSize + "px"
        style["font-Family"] = this.options.serialNumberRankTextFontFamily
        style["font-weight"] = this.options.serialNumberRankTextFontWeight
        style["color"] = this.$parseColor(this.options.serialNumberRankTextFontColor)
        if (this.options.serialNumberShowSerialNumberBg) {
          // 显示序号背景
          switch (this.options.serialNumberBgType) {
            case "round":
              style["width"] = this.options.serialNumberBgW + "px"
              style["height"] = this.options.serialNumberBgW + "px"
              style["line-height"] = this.options.serialNumberBgH + "px"
              style["text-align"] = "center"
              style["border-radius"] = "50%"
              style["background-color"] = this.$parseColor(this.options.serialNumberBgColor)
              break
            case "roundedRectangle":
              style["width"] = this.options.serialNumberBgW + "px"
              style["height"] = this.options.serialNumberBgH + "px"
              style["line-height"] = this.options.serialNumberBgH + "px"
              style["text-align"] = "center"
              style["border-radius"] = this.options.serialNumberBgRadius + "px"
              style["background-color"] = this.$parseColor(this.options.serialNumberBgColor)
              break
            case "diamond":
              style["width"] = this.options.serialNumberBgW + "px"
              style["height"] = this.options.serialNumberBgW + "px"
              style["line-height"] = this.options.serialNumberBgH + "px"
              style["text-align"] = "center"
              style["background-color"] = this.$parseColor(this.options.serialNumberBgColor)
              style["transform"] = "rotate(45deg)"
              break
            case "image":
              style["width"] = this.options.serialNumberBgW + "px"
              style["height"] = this.options.serialNumberBgW + "px"
              style["line-height"] = this.options.serialNumberBgH + "px"
              style["text-align"] = "center"
              style["background-image"] = "url(" + this.options.serialNumberBgImg + ")"
              style["background-size"] = "cover"
              style["background-position"] = "center"
              style["border-radius"] = this.options.serialNumberBgRadius + "px"
              style["background-color"] = this.$parseColor(this.options.serialNumberBgColor)
              break
          }
        }
      }
      return style
    },
    serialNumberSpecialRowsStyle(index) {
      let style = {}
      if (this.options.isShowSerialNumber) {
        for (let i = 0; i < this.options.serialNumberSpecialRows.length; i++) {
          if (this.options.serialNumberSpecialRows[i].rowIndex === index + 1) {
            style = {
              "font-Family": this.options.serialNumberSpecialRows[i].specialFontFamily,
              "font-size": this.options.serialNumberSpecialRows[i].specialFontSize + "px",
              "font-weight": this.options.serialNumberSpecialRows[i].specialFontWeight,
              color: this.$parseColor(this.options.serialNumberSpecialRows[i].specialFontColor),
              "background-color": this.$parseColor(this.options.serialNumberSpecialRows[i].specialBgColor),
              "background-image": "url(" + this.options.serialNumberSpecialRows[i].specialBgImg + ")",
              "background-size": "cover",
              "background-position": "center"
            }
          }
        }
        return style
      }
    },
    thStyle(index, isRankCol,isDynamicData) {
      let style = {}
      if (this.colsWidthType === "default") {
        style["width"] = 100 / this.options.headerData.length + "%"
        style["text-align"] = "center"
      } else {
        style["width"] = this.options.colsWidthList[index] + "%"
        if(this.options.rankWidth && isRankCol){
          style["width"] = this.options.rankWidth + "%"
        }
      }
      if (!this.options.isShowSerialNumber && this.options.headerTextAlign) {
        style["text-align"] = this.options.headerTextAlign
      }
      if(isRankCol){
        style["text-align"] = this.options.rankAlign || "center"
      }
      if(isDynamicData){
        style["text-align"] = this.options.dynamicDataAlign || 'center'
      }
      return style
    },
    tdStyle(index, isRankCol) {
      let style = {}
      if (this.colsWidthType === "default") {
        style["width"] = 100 / this.options.headerData.length + "%"
      } else {
        style["width"] = this.options.colsWidthList[index] + "%"
        if(this.options.rankWidth && isRankCol){
          style["width"] = this.options.rankWidth + "%"
        }
      }
      return style
    },
    // 数据组中的样式, 不包括序号列
    dataGroupHeaderStyle(index) {
      let style = {}
      if (this.options.isShowSerialNumber) {
        style["text-align"] = this.options.serialNumberHeaderData[index]
          ? this.options.serialNumberHeaderData[index].align
          : "center"
      }
      return style
    },
    dataGroupContentStyle(index) {
      let style = {}
      if (this.options.isShowSerialNumber) {
        if (this.options.serialNumberHeaderData[index].type === "text") {
          style["font-size"] = this.options.serialNumberHeaderData[index].fontSize + "px"
          style["font-family"] = this.options.serialNumberHeaderData[index].fontFamily
          style["font-weight"] = this.options.serialNumberHeaderData[index].fontWeight
          style["color"] = this.$parseColor(this.options.serialNumberHeaderData[index].fontColor)
        }
        if (this.options.serialNumberHeaderData[index].type === "image") {
          style["width"] = this.options.serialNumberHeaderData[index].width + "px"
          style["height"] = this.options.serialNumberHeaderData[index].height + "px"
          style["border-radius"] = this.options.serialNumberHeaderData[index].borderRadius + "px"
        }
        style["text-align"] = this.options.serialNumberHeaderData[index].align
      }
      return style
    },
    // 获取数据的显示方式，文本或者图片
    getValueDisplayType(index) {
      if (this.options.isShowSerialNumber) {
        return this.options.serialNumberHeaderData[index]?.type
      }
    },
    serialNumberStyle() {
      return {
        display: "flex",
        "align-items":  "center",
        "justify-content": this.options.rankAlign ||"center"
      }
    },
    specialRowsStyle(index) {
      let style = {}
      for (let i = 0; i < this.options.specialRows.length; i++) {
        if (Number(this.options.specialRows[i].rowIndex) === index + 1) {
          style = {
            "font-Family": this.options.specialRows[i].specialFontFamily,
            "font-size": this.options.specialRows[i].specialFontSize + "px",
            "font-weight": this.options.specialRows[i].specialFontWeight,
            color: this.$parseColor(this.options.specialRows[i].specialFontColor),
            backgroundColor: this.$parseColor(this.options.specialRows[i].specialBgColor)
          }
        }
      }
      return style
    },
    // 动态数据中的样式
    dynamicDataStyle(index, index1) {
      let style = {}
      if (this.options.isShowSerialNumber) {
        for (let i = 0; i < this.dynamicDataStyleList.length; i++) {
          const dynamicDataStyleListItem = this.dynamicDataStyleList[i]
          if (index === dynamicDataStyleListItem.index) {
            style = dynamicDataStyleListItem.style
          }
        }
      }
      style["text-align"] = this.options.dynamicDataAlign || "center"
      if (this.options.isShowSerialNumber && this.dynamicDataStyleList.length === 0) {
        //  没有动态数据，则最后一列使用普通数据样式
        if (index1 < this.options.serialNumberHeaderData.length) {
          style = this.dataGroupContentStyle(index1)
        }
      }
      if (!this.options.isShowSerialNumber && this.options.textAlign) {
        style["text-align"] = this.options.textAlign
      }
      return style
    },
    // 字符串脱敏
    formatStr(index, str) {
      if (this.options.isShowSerialNumber) {
        if (this.options.serialNumberHeaderData[index].isDesensitization || str.length < 2) {
          if (this.options.serialNumberHeaderData[index].isDesensitizationCenter == "true" && str.length > 2) {
            return str.substring(0, 1) + new Array(str.length - 1).join("*") + str.charAt(str.length - 1)
          } else {
            return str.substring(0, 1) + new Array(str.length).join("*")
          }
        } else {
          return str
        }
      }
    },
    // 点击表格行，打开详情页
    getDetailsPageUrl(index) {
      if (!this.isBigScreenPreview()) return
      if (this.listOtherData[index]?.url) {
        return this.listOtherData[index].url
      }
    },
    changeFilterValue() {
      const value = typeof this.filterValue === "number" ? this.filterList[this.filterValue] : ""
      this.$changeOptionsEV(value, "filterValue", false, null, this.myid, true)
      this.$changeOptionsEV(true, "hasSearch", false, null, this.myid, true)
      this.isSearch = true
      this.updateData()
    },
    requestNextPage() {
      //预览页中
      // 表格数据在自动滚动时，需要判断：以50条分页为例，若数据大于50条，需要在开始滚动时请求第二页数据，当滚动到第二页的第一条时需要请求第三页数据，以此类推。
      //自动滚动位置：在滚动需要请求下一页时，判断当前数据量是否小于总数据量，小于则请求下一页，大于或者等于则不请求，
      if (
        this.isBigScreenPreview() &&
        this.totalRecords > this.dataAllBox.length &&
        this.totalRecords > this.pageSize
      ) {
        this.pageNum++
        this.updateData()
      }
    },
    setSelfScroll() {
      if (!this.$refs.tableScroll) {
        return
      }
      let bodyHeight = this.options.height - this.options.headerHeight
      if (this.request_prefix !== "bigScreen") {
        bodyHeight = this.$refs.tableBox.clientHeight - this.options.headerHeight
        if (this.options.openTableFilter) {
          bodyHeight = bodyHeight - (this.$refs.tableFilter.$el.clientHeight + 12)
        }
      }
      if (this.openPagination) {
        // 减去分页高度
        bodyHeight = bodyHeight - 42
      }
      if (this.options.scrollAutoSelf && !this.options.turnOnScroll) {
        this.$refs.tableScroll.$el.style.height = bodyHeight + "px"
        this.$refs.tableScroll.$el.classList.add("table-scrolL-body")
        if (this.request_prefix !== "bigScreen") {
          this.$refs.tableScroll.$el.classList.add("scroll-bar-light")
        }
      } else {
        if (this.openPagination) {
          this.$refs.tableScroll.$el.style.height = bodyHeight + "px"
        } else {
          this.$refs.tableScroll.$el.style.height = "auto"
        }
        this.$refs.tableScroll.$el.classList.remove("table-scrolL-body")
        if (this.request_prefix !== "bigScreen") {
          this.$refs.tableScroll.$el.classList.remove("scroll-bar-light")
        }
      }
    },
    handleCurrentChange(curPage) {
      // 选中页码发生改变
      console.log('curPage :>>',curPage);
      this.currentPage = curPage
      // this.pageSize = this.options.showRows
      this.pageNum = curPage
      this.updateData()
    },
    async getGeneralRest(appId, wfwfid, websiteId, pageId) {
      return this.$API.queryAppCategoryAndApp({
        appId: appId,
        wfwfid: wfwfid,
        websiteId: websiteId,
        pageId: pageId
      })
    },
    async etEngineInstance(){
      const { pageId, wfwfid, websiteId } = this.$store.state.states.getDataPageIds
      const appId = this.options.appId
      let res = await this.getGeneralRest(appId, wfwfid, websiteId, pageId)
      if(res.data.code === 1){
        this.$changeOptionsEV(res.data.data.engineInstance.id, "engineInstanceId_10", false, null, this.myid, true)
      }
    }
  }
}
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 10px;
}
.tableComponent {
  margin: 0 auto;
  overflow: hidden;
}
.tableComponent.table-scrolL-body {
  overflow: auto;
}
.table-scrolL-body::-webkit-scrollbar {
  display: block;
}
.scroll-bar-light::-webkit-scrollbar {
  width: 8px;
  height: 6px;
}
/* //滚动条的滑块 */
.scroll-bar-light::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.tableComponent ul {
  list-style: none;
  margin: 0 auto;
}
.tableComponent li,
a {
  display: flex;
  justify-content: space-between;
  padding-left: 10px;
}
/*.tableComponent li div {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}*/
.rotate_45 {
  display: inline-block;
  transform: rotate(-45deg);
}
a {
  text-decoration: none;
  color: inherit;
}
a:hover,
a:visited,
a:link,
a:active {
  color: inherit;
}
.select-box {
  display: block;
  margin-bottom: 12px;
}
::v-deep .select-box .el-input .el-input__inner {
  border: 1px solid #e9eef3;
  background: transparent;
  padding-right: 28px;
}
::v-deep .select-box .el-input .el-input__inner:focus {
  box-shadow: inset 0px 0px 0px 1px #e9eef3;
}
::v-deep .table-pagination {
  position: absolute;
  bottom: 0;
  height: 42px;
  width: 100%;
  display: flex;
  align-items: center;
}
::v-deep .table-pagination .el-pagination {
  width: 100%;
}
::v-deep .table-pagination .el-pager li {
  background: transparent;
  min-width: 22px;
  height: 22px;
  line-height: 22px;
  font-weight: 400;
  font-size: var(--fontSize);
  color: var(--fontColor);
}
::v-deep .table-pagination .el-pager li.active {
  color: var(--activeFontColor);
}
::v-deep .table-pagination button {
  background: transparent;
  min-width: 22px;
  height: 22px;
  line-height: 22px;
  padding-right: 0;
  padding-left: 0;
  color: var(--subTextColor);
}
::v-deep .el-pagination button:disabled {
  color: var(--fourthTextColor);
  background: transparent;
}
.time-box {
  height: 44px;
}
</style>
